import { Parent, UpdateParent } from '../models/parent.interface';

import { mapFromChildDto } from '../../child';
import { ParentDto, UpdateParentDto } from '../dto';

export function mapFromParentDto(dto: ParentDto): Parent {
  return {
    id: dto.id ?? null,
    firstName: dto.first_name ?? null,
    lastName: dto.last_name ?? null,
    email: dto.email ?? null,
    phoneCode: dto.phone_code ?? undefined,
    phoneNumber: dto.phone_number ?? undefined,
    emergencyContact: {
      name: dto.emergency_contact?.name ?? null,
      phoneCode: dto.emergency_contact?.phone_code ?? null,
      phoneNumber: dto.emergency_contact?.phone_number ?? null,
    },

    trustedDevice: {
      id: dto.trusted_device?.id,
      createdAt: dto.trusted_device?.created_at ?? null,
      updatedAt: dto.trusted_device?.updated_at ?? null,
      name: dto.trusted_device?.name ?? null,
      os: dto.trusted_device?.os ?? null,

      parentUser: {
        id: dto.trusted_device?.parent_user?.id ?? null,
        email: dto.trusted_device?.parent_user?.email ?? null,
        firstName: dto.trusted_device?.parent_user?.first_name ?? null,
        lastName: dto.trusted_device?.parent_user?.last_name ?? null,
        photoUrl: dto.trusted_device?.parent_user?.photo_url ?? null,
      },
    },

    familyMembersCount: {
      childUsers: dto.family_members_count?.child_users ?? null,
      parentUsers: dto.family_members_count?.parent_users ?? null,
    },

    familyMembers: {
      childUsers: dto.family_members?.child_users?.map((childDto) => mapFromChildDto(childDto)) ?? [],
      parentUsers: dto.family_members?.parent_users?.map((parentDto) => mapFromParentDto(parentDto)) ?? [],
    },

    createdAt: dto.created_at ?? null,
    updatedAt: dto.updated_at ?? null,
    photoUrl: dto.photo_url ?? null,
    isPrimaryParent: dto.is_primary_parent ?? false,
  };
}

export function mapUpdateParentToDto(parent: UpdateParent): UpdateParentDto {
  return {
    first_name: parent.firstName ?? null,
    last_name: parent.lastName ?? null,
    email: parent.email ?? null,
    phone_code: parent.phoneCode ?? undefined,
    phone_number: parent.phoneNumber ?? undefined,
    emergency_contact: {
      name: parent.emergencyContactName ?? null,
      phone_code: parent.emergencyContactPhoneCode ?? null,
      phone_number: parent.emergencyContactPhoneNumber ?? null,
    },
  };
}

export function mapFromParentToUpdateParent(parent: Parent): UpdateParent {
  return {
    firstName: parent.firstName ?? '',
    lastName: parent.lastName ?? '',
    email: parent.email ?? '',
    phoneCode: parent.phoneCode ?? '',
    phoneNumber: parent.phoneNumber ?? '',
    emergencyContactName: parent.emergencyContact?.name ?? '',
    emergencyContactPhoneCode: parent.emergencyContact?.phoneCode ?? '',
    emergencyContactPhoneNumber: parent.emergencyContact?.phoneNumber ?? '',
  };
}
